import { IndeterminateProgressCircle } from '@sunwebgroup/uds-ui/IndeterminateProgressCircle'
import { useUserReviews, useUserReviewsInitialData } from '@/scopes/products/user-reviews/hooks'
import styles from './Content.module.css'
import { Overview } from './Overview'
import { Result } from './Result'

export function Content() {
  const { isLoading } = useUserReviews()
  const { reviewsAmount, isFetched } = useUserReviewsInitialData()

  if (isLoading) {
    return (
      <div className={styles.wrapperLoading}>
        <IndeterminateProgressCircle />
      </div>
    )
  }

  if (isFetched && reviewsAmount < 3) {
    return (<Result />)
  }

  return (
    <div className={styles.wrapper}>
      <Overview />
      <Result />
    </div>
  )
}
